import { render, staticRenderFns } from "./PersonDetailView.vue?vue&type=template&id=93421672&scoped=true&"
import script from "./PersonDetailView.vue?vue&type=script&lang=ts&"
export * from "./PersonDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93421672",
  null
  
)

export default component.exports